const topicItems = [
  { label: '热血漫画', count: '12.8万', bgClass: 'bg-primary-100', textClass: 'text-primary-700' },
  { label: '恋爱漫画', count: '9.6万', bgClass: 'bg-primary-100/70', textClass: 'text-primary-600' },
  { label: '奇幻漫画', count: '8.3万', bgClass: 'bg-accent-100', textClass: 'text-accent-700' },
  { label: '悬疑漫画', count: '6.5万', bgClass: 'bg-secondary-100', textClass: 'text-secondary-700' },
  { label: '搞笑漫画', count: '7.2万', bgClass: 'bg-accent-100/70', textClass: 'text-accent-600' },
  { label: '科幻漫画', count: '5.4万', bgClass: 'bg-secondary-100/70', textClass: 'text-secondary-600' },
  { label: '古风漫画', count: '4.9万', bgClass: 'bg-primary-100/50', textClass: 'text-primary-700' },
  { label: '都市漫画', count: '6.1万', bgClass: 'bg-accent-100/50', textClass: 'text-accent-700' },
  { label: '冒险漫画', count: '5.8万', bgClass: 'bg-secondary-100/50', textClass: 'text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">大家都在讨论的热门漫画话题与分类</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl ${item.bgClass} hover:scale-105 transition-transform duration-200 cursor-pointer`}
            >
              <span className={`text-sm font-semibold whitespace-nowrap ${item.textClass}`}>{item.label}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count} 作品</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}